//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import Teachers from './teachers';
import Trailer from './trailer';
import Price from '../-price';
import parseYoutubeLinkToId from '../../../../utils/parseYoutubeLinkToId';
import Loader from '@/components/autoscale/loader';

export default {
  components: {
    Teachers,
    Trailer,
    Price,
    Loader,
  },
  props: {
    isSaleWithoutPrice: {
      type: Boolean,
    },
  },
  computed: {
    youtubeVideoId() {
      const trailerUrl =
        this.$store.state.sale.detailProductDialog.content.trailerUrl;
      return parseYoutubeLinkToId(trailerUrl);
    },
    skillsColOne() {
      const skills = this.$store.state.sale.detailProductDialog.content.skills;
      return skills.filter((v, i) => i % 2 === 0);
    },
    skillsColTwo() {
      const skills = this.$store.state.sale.detailProductDialog.content.skills;
      return skills.filter((v, i) => i % 2 !== 0);
    },
    productShowcaseImage() {
      return this.$store.state.sale.detailProductDialog?.product?.images
        ?.showcaseImage;
    },
    computedSlug() {
      return this.$store.state.sale.detailProductDialog?.product?.slug;
    },
    productShowcaseImageUrl() {
      return this.productShowcaseImage
        ? this.productShowcaseImage?.url
        : undefined;
    },
    productImageUrlFromSlug() {
      return this.computedSlug
        ? `/images/nomenclatures/${this.computedSlug}.svg`
        : undefined;
    },
    productImageUrl() {
      return this.productShowcaseImageUrl || this.productImageUrlFromSlug;
    },
    computedPricePercent() {
      return this.$store.state.sale?.detailProductDialog?.product?.price
        ?.percent;
    },
    computedBasePriceFormatted() {
      return this.$store.state.sale?.detailProductDialog?.product?.price
        ?.basePriceFormatted;
    },
    computedPriceInstallmentPlan() {
      return this.$store.state.sale?.detailProductDialog?.product?.price
        ?.priceInstallmentPlan;
    },
    computedPriceInstallmentPlanPrice() {
      return this.$store.state.sale?.detailProductDialog?.product?.price
        ?.priceInstallmentPlanPrice;
    },
  },
  watch: {
    async '$store.state.sale.detailProductDialog.loading'(value) {
      this.debug({
        name: 'watch $store.state.sale.detailProductDialog.loading',
      });

      if (!value) {
        await this.scrollToTop();
      }
    },
  },
  methods: {
    openFile() {
      this.debug({ name: 'openFile' });

      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_click',
        eventAction: 'pdf',
        eventLabel: this.$store.state.sale.detailProductDialog.content.title,
      });

      window.open(
        this.$store.state.sale.detailProductDialog.content.courseProgram.url,
        '_blank',
      );
    },
    addToBasket() {
      this.debug({ name: 'addToBasket' });

      this.$store.commit('sale/setDetailProductDialog', {
        ...this.$store.state.sale.detailProductDialog,
        product: {
          ...this.$store.state.sale.detailProductDialog.product,
          inBasket: true,
        },
      });

      this.debug({ name: 'addToBasket' }, 'emit addToBasket');
      this.$emit('addToBasket', {
        item: this.$store.state.sale.detailProductDialog.product,
        type: this.$store.state.sale.detailProductDialog.productType,
      });
    },
    removeFromBasket() {
      this.debug({ name: 'removeFromBasket' });

      this.$store.commit('sale/setDetailProductDialog', {
        ...this.$store.state.sale.detailProductDialog,
        product: {
          ...this.$store.state.sale.detailProductDialog.product,
          inBasket: false,
        },
      });

      this.debug({ name: 'removeFromBasket' }, 'emit removeFromBasket');
      this.$emit('removeFromBasket', {
        item: this.$store.state.sale.detailProductDialog.product,
        type: this.$store.state.sale.detailProductDialog.productType,
      });
    },
    closeDialog() {
      this.debug({ name: 'closeDialog' });
      this.debug({ name: 'closeDialog' }, 'emit close');
      this.$emit('close');
    },
    openBasket() {
      this.debug({ name: 'openBasket' });
      this.debug({ name: 'openBasket' }, 'emit open-basket');
      this.$emit('open-basket');
    },
    async scrollToTop() {
      this.debug({ name: 'scrollToTop' });

      await Vue.nextTick();

      if (this.$refs?.contentWrapper?.scrollTop) {
        this.$refs.contentWrapper.scrollTop = 0;
      }
    },
  },
};
